import { Command } from 'ckeditor5';
import { ConditionState } from './State';
/**
 * Returns true when ranges A and B interlace (partial overlap without full containment).
 * Concretely: a1 < b1 < a2 < b2  OR  b1 < a1 < b2 < a2.
 * Proper nesting and disjoint ranges both return false.
 */
function interlaces(a, b) {
    const { start: a1, end: a2 } = a;
    const { start: b1, end: b2 } = b;
    return ((a1.isBefore(b1) && b1.isBefore(a2) && a2.isBefore(b2)) || (b1.isBefore(a1) && a1.isBefore(b2) && b2.isBefore(a2)));
}
export class InsertConditionCommand extends Command {
    static get pluginName() {
        return 'insertCondition';
    }
    constructor(editor) {
        super(editor);
        this.state = this.editor.plugins.get(ConditionState);
    }
    refresh() {
        const { model } = this.editor;
        const { selection } = model.document;
        if (selection.isCollapsed) {
            this.isEnabled = false;
            return;
        }
        const range = selection.getFirstRange();
        if (!range) {
            this.isEnabled = false;
            return;
        }
        this.isEnabled = !this.wouldInterlace(range);
    }
    addCondition(options) {
        const { id, type } = options;
        const { model } = this.editor;
        model.change((writer) => {
            const { selection } = model.document;
            const firstRange = selection.getFirstRange();
            if (!firstRange || firstRange.isCollapsed) {
                return;
            }
            if (this.wouldInterlace(firstRange)) {
                return;
            }
            const name = `${type}:${id}`;
            writer.addMarker(`condition-inline:${name}`, {
                usingOperation: true,
                affectsData: true,
                range: firstRange,
            });
            this.state.addCondition(name);
            writer.setSelection(firstRange.end);
        });
    }
    wouldInterlace(range) {
        for (const marker of this.editor.model.markers) {
            if (!marker.name.startsWith('condition-inline:') && !marker.name.startsWith('condition-block:')) {
                // eslint-disable-next-line no-continue
                continue;
            }
            if (interlaces(range, marker.getRange())) {
                return true;
            }
        }
        return false;
    }
}
